import * as React from 'react';
import * as styles from './styles.css';

interface ILayoutProps extends React.PropsWithChildren {
  dataTestId?: string;
  stretch?: boolean;
  id?: string;
}

export const Layout: React.FC<ILayoutProps> = ({ children, dataTestId, stretch, id }) => {
  return (
    <div className={stretch ? styles['stretch'] : styles['container']} data-testid={dataTestId} id={id}>
      {children}
    </div>
  );
};
